import { render, staticRenderFns } from "./ChartLoadingContainer.vue?vue&type=template&id=98fa3bd8&scoped=true&"
import script from "./ChartLoadingContainer.vue?vue&type=script&lang=js&"
export * from "./ChartLoadingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fa3bd8",
  null
  
)

export default component.exports